export const TestIds = {
  section: 'section-container',
} as const;
